import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-account-tabs',
  templateUrl: './account-tabs.component.html',
  styleUrls: ['./account-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AccountTabsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
